var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"Facturas Vencidas","visible":_vm.DriwerVisible,"size":"50%","append-to-body":""},on:{"close":_vm.Onclose}},[_c('el-row',[_c('el-col',[_c('rabbey-table-3',{ref:"table",attrs:{"loading":_vm.TableLoading,"columns":_vm.columns,"data":_vm.Items}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }